// src/utils/draftNumberNotice.js
// ✅ 기안 통합 저장(combined_create) 응답의 최종 기안번호 안내 + 저장 실패 메시지.
// 기안번호는 서버가 저장 시점에 다시 정한다 — 화면에 보이던 번호가 그새 쓰였으면
// 다음 빈 번호로 저장되므로, 그 사실을 사용자가 모르고 지나치지 않게 따로 알린다.

// draft_number = { requested_draft_no, draft_no, draft_no_changed } (서버 build_draft_number_result)
export function draftNumberChangedLine(info) {
  if (!info?.draft_no_changed) return "";
  // 기안번호는 항상 "…호"로 끝나 받침이 없다 → 조사는 "가"/"로" 고정
  return `⚠️ 화면의 ${info.requested_draft_no}가 이미 사용 중이라 ${info.draft_no}로 저장되었습니다.`;
}

// 여러 건(청구형 내부기안/공문)의 안내를 한 덩어리로
export function draftNumberChangedLines(infos) {
  return (infos || []).map(draftNumberChangedLine).filter(Boolean).join("\n");
}

// 저장 실패 alert 문구 — DRF unique 오류는 영어 원문("... already exists.")이라 번역해 보여준다.
export function formatDraftSaveError(err) {
  const data = err?.response?.data;
  if (!data) return `저장 실패: ${err?.message || "알 수 없는 오류"}`;
  if (data.draft_no) {
    return "저장 실패: 같은 기안번호의 문서가 이미 있습니다.\n화면을 새로고침한 뒤 다시 저장해 주세요.";
  }
  if (typeof data.detail === "string") return `저장 실패: ${data.detail}`;
  return `저장 실패: ${JSON.stringify(data)}`;
}
